<template>
  <a-drawer width="80%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item :label="t.type" prop="type">
        <a-select v-model="form.type" :placeholder="t.select">
          <a-select-option :value="0">{{ t.gold }}</a-select-option>
          <a-select-option :value="1">{{ t.vip }}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item :label="t.value" prop="numberValue">
        <a-input-number v-model="form.numberValue" :min="1" :placeholder="t.input" style="width: 100%" />
      </a-form-model-item>
      <a-form-model-item v-if="formType === 1" :label="t.count" prop="targetCount">
        <a-input-number v-model="form.targetCount" :min="1" :placeholder="t.input" style="width: 100%" />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">{{ t.save }}</a-button>
          <a-button type="dashed" @click="cancel">{{ t.cancel }}</a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getKoc, addKoc, updateKoc } from '@/api/user/koc'

const T = {
  type: '\u7c7b\u578b',
  value: '\u91d1\u5e01\u6570\u91cf/\u4f1a\u5458\u5929\u6570',
  count: '\u751f\u6210\u6570\u91cf',
  gold: '\u91d1\u5e01\u5361',
  vip: '\u4f1a\u5458\u5361',
  select: '\u8bf7\u9009\u62e9',
  input: '\u8bf7\u8f93\u5165',
  save: '\u4fdd\u5b58',
  cancel: '\u53d6\u6d88',
  addTitle: '\u65b0\u589e\u5151\u6362\u7801',
  editTitle: '\u4fee\u6539\u5151\u6362\u7801',
  addOk: '\u65b0\u589e\u6210\u529f',
  editOk: '\u4fee\u6539\u6210\u529f',
  typeReq: '\u7c7b\u578b\u4e0d\u80fd\u4e3a\u7a7a',
  valueReq: '\u6570\u503c\u4e0d\u80fd\u4e3a\u7a7a',
  countReq: '\u751f\u6210\u6570\u91cf\u4e0d\u80fd\u4e3a\u7a7a'
}

export default {
  name: 'CreateForm',
  data () {
    return {
      t: T,
      submitLoading: false,
      formTitle: '',
      form: {
        id: null,
        type: 0,
        numberValue: null,
        targetCount: 1,
        remark: null
      },
      formType: 1,
      open: false,
      rules: {
        type: [{ required: true, message: T.typeReq }],
        numberValue: [{ required: true, message: T.valueReq }],
        targetCount: [{ required: true, message: T.countReq }]
      }
    }
  },
  methods: {
    onClose () { this.open = false },
    cancel () {
      this.open = false
      this.reset()
    },
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        type: 0,
        numberValue: null,
        targetCount: 1,
        remark: null
      }
      this.$nextTick(() => {
        if (this.$refs.form) this.$refs.form.clearValidate()
      })
    },
    handleAdd () {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = T.addTitle
    },
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      getKoc({ id: row ? row.id : ids }).then(response => {
        this.form = Object.assign({}, this.form, response.data || {})
        this.open = true
        this.formTitle = T.editTitle
      })
    },
    submitForm () {
      this.$refs.form.validate(valid => {
        if (!valid) return false
        this.submitLoading = true
        const req = this.form.id ? updateKoc(this.form) : addKoc(this.form)
        req.then(() => {
          this.$message.success(this.form.id ? T.editOk : T.addOk)
          this.open = false
          this.$emit('ok')
        }).finally(() => {
          this.submitLoading = false
        })
      })
    }
  }
}
</script>
